import { Button, Form, Input, message, Select, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { fetchCities } from "../city/FetchCities";
import { fetchPincode } from "./FetchPincode";
import { EditOutlined } from "@ant-design/icons";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { create_pincode, update_pincode } from "../../endpoints/API";

const Pincode = () => {
  const baseUrl = useSelector(selectBaseUrl);
  const prodTestUrl = useSelector(selectProdTestUrl);
  const [cities, setCities] = useState([]);
  const [pincodes, setPincodes] = useState([]);
  const isUser = useSelector((state) => state.user.user);
  const [form] = Form.useForm();
  const [editingId, setEditingId] = useState(null); // To track the editing state

  useEffect(() => {
    const fetchCitiesData = async () => {
      try {
        await fetchCities(setCities, baseUrl, prodTestUrl);
        await fetchPincode(setPincodes, baseUrl, prodTestUrl);
      } catch (error) {
        message.error(error?.response?.data?.error||"Failed to fetch cities or pincodes.");
      }
    };

    fetchCitiesData();
  }, []);

  const onFinish = async (values) => {
    try {
      const payload = {
        created_by: isUser.user_id,
        pin: values.pincode,
        city: values.city,
        ...(editingId && { id: editingId }), // Only include id if editing
      };

      let response;

      if (editingId) {
        response = await update_pincode(payload);
      } else {
        response = await create_pincode(payload);
      }

      if (response.statusText=="OK") {
        await fetchPincode(setPincodes, baseUrl, prodTestUrl); // Refresh the table data
        form.resetFields(); // Reset the form fields
        setEditingId(null); // Reset editing ID after submission
        message.success(
          editingId
            ? "Pincode updated successfully!"
            : "Pincode added successfully!"
        );
      } else {
        const errorData = response?.data;
        message.error("Pincode already exists.");
      }
    } catch (error) {
      message.error(error?.response?.data?.error||"An error occurred while adding/updating the pincode.");
    }
  };

  const handleEdit = (record) => {
    setEditingId(record.id); // Set the ID of the pincode being edited
    form.setFieldsValue({
      pincode: record.pin,
      city: record.city.id, // Assuming city is an object with an id
    });
  };

  const columns = [
    {
      title: "Pincode",
      dataIndex: "pin",
      key: "pin",
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      render: (city) => city?.name,
    },
    {
      title: "Edit",
      key: "edit",
      render: (text, record) => (
        <Button onClick={() => handleEdit(record)}>
          <EditOutlined />
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Form form={form} onFinish={onFinish}>
        <div
          className="border flex gap-5 p-4 items-center rounded-lg shadow-md"
          style={{ padding: "16px" }}
        >
          <Form.Item
            label={<span className="font-semibold">Add Pincode</span>}
            name="pincode"
            rules={[{ required: true, message: "Please enter pincode!" }]}
            style={{ margin: "0" }}
          >
            <Input placeholder="Enter Pincode" style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item
            label={<span className="font-semibold">Select City</span>}
            name="city"
            rules={[{ required: true, message: "Please select a city!" }]}
            style={{ margin: "0" }}
          >
            <Select placeholder="Select city" style={{ width: "100%" }}>
              {cities.map((city) => (
                <Select.Option key={city.id} value={city.id}>
                  {city.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item style={{ margin: "0" }}>
            <Button type="primary" htmlType="submit">
              {editingId ? "Update" : "Save"}
            </Button>
          </Form.Item>
        </div>
      </Form>
      <Table dataSource={pincodes} columns={columns} rowKey="id" />
    </div>
  );
};

export default Pincode;
